var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('td',{staticClass:"files-list__row-checkbox"},[(_vm.isLoading)?_c('NcLoadingIcon'):_c('NcCheckboxRadioSwitch',{attrs:{"aria-label":_vm.t('files', 'Select the row for {displayName}', { displayName: _vm.displayName }),"checked":_vm.isSelected},on:{"update:checked":_vm.onSelectionChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }